// src/pages/CatalogoPage.js
import React, { useState } from 'react';
import { catalogoData } from '../data'; // 1. Importamos la lista de productos
import ProductCard from '../components/ProductCard'; // 2. Importamos la tarjeta que ya creamos
import './CatalogoPage.css'; // 3. Importamos los estilos que crearemos para esta página

const CatalogoPage = () => {
  // Estado para la categoría seleccionada
  const [selectedCategory, setSelectedCategory] = useState('Todas');

  // Obtener todas las categorías únicas
  const categories = ['Todas', ...new Set(catalogoData.map(product => product.categoria))];

  // Filtrar productos según la categoría seleccionada
  const filteredProducts = selectedCategory === 'Todas' 
    ? catalogoData 
    : catalogoData.filter(product => product.categoria === selectedCategory);

  return (
    <div className="catalog-page">
      <div className="container">
        <h1 className="catalog-title">Nuestro Catálogo Completo</h1>
        <p className="catalog-subtitle">
          Explora toda nuestra variedad de productos congelados, listos para preparar.
        </p>

        {/* Filtros por categoría */}
        <div className="category-filters">
          {categories.map((category) => (
            <button
              key={category}
              className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Cuadrícula de productos */}
        <div className="product-grid">
          {filteredProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CatalogoPage;